import type { RouteConfig } from 'vue-router';

export const employeeGroupsRoutes: Array<RouteConfig> = [
  {
    path: 'employee-groups',
    name: 'employee-groups',
    redirect: '/v3/time-tracking/employee-groups',
    meta: {
      title: 'employee_groups',
    },
  },
];
